export type ClinicDayKey = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export type ClinicStatus = 'open' | 'closed' | 'partial';

export type ClinicScheduleRow = {
  label: string;
  statusByDay: Record<ClinicDayKey, ClinicStatus>;
  sub?: string;
};

type ClinicPhone = {
  display: string;
  href: `tel:${string}`;
};

type ClinicAddress = {
  postalCode: string;
  prefecture: string;
  city: string;
  street: string;
  display: string;
};

type ClinicHours = {
  morning: string;
  afternoon: string;
  saturdayAfternoon: string;
};

export type ClinicSettings = {
  phone: ClinicPhone;
  address: ClinicAddress;
  hours: ClinicHours;
  schedule: readonly ClinicScheduleRow[];
  parking: string;
};

const phoneDigits = '0268641182';

const clinicHours = {
  morning: '8:30〜12:30',
  afternoon: '14:00〜18:00',
  saturdayAfternoon: '13:30〜17:30',
} as const satisfies ClinicHours;

const clinicSchedule: readonly ClinicScheduleRow[] = [
  {
    label: clinicHours.morning,
    statusByDay: {
      mon: 'open',
      tue: 'open',
      wed: 'open',
      thu: 'closed',
      fri: 'open',
      sat: 'open',
      sun: 'closed',
    },
  },
  {
    label: clinicHours.afternoon,
    statusByDay: {
      mon: 'open',
      tue: 'open',
      wed: 'open',
      thu: 'closed',
      fri: 'open',
      sat: 'partial',
      sun: 'closed',
    },
  },
];

export const clinicSettings = {
  phone: {
    display: '0268-64-1182',
    href: `tel:${phoneDigits}`,
  },
  address: {
    postalCode: '389-0515',
    prefecture: '長野県',
    city: '東御市',
    street: '常田898−1',
    display: '〒389-0515 長野県東御市常田898−1',
  },
  hours: clinicHours,
  schedule: clinicSchedule,
  parking: '22台完備',
} as const satisfies ClinicSettings;
